import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Navigate } from "react-router-dom";
import {
  Card,
  Grid,
  TextField,
  MenuItem,
  IconButton,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

export default class AddProject extends Component {
  state = {
    project_name: "",
    project_category: "",
    project_location: "",
    project_type: "",
    industry: "",
    project_overview: "",

    challenges: [""],
    solutions: [""],
    key_info: [{ key: "", value: "" }],

    project_banner: null,
    project_gallery: [],

    categories: [],
    loading: false,
    notification: false,
    message: "",
    redirect: false,
  };

  componentDidMount() {
    this.getCategories();
  }

  getCategories = async () => {
    if (init() !== "success") return;
    try {
      const resp = await axios.get(Constants.getUrls.getAllProjectCategories);
      this.setState({ categories: resp?.data?.data || [] });
    } catch (err) {
      console.error("Category fetch failed", err);
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleArrayChange = (type, index, value) => {
    const arr = [...this.state[type]];
    arr[index] = value;
    this.setState({ [type]: arr });
  };

  handleKeyInfoChange = (index, field, value) => {
    const data = [...this.state.key_info];
    data[index][field] = value;
    this.setState({ key_info: data });
  };

  addItem = (type, emptyValue) => {
    this.setState({ [type]: [...this.state[type], emptyValue] });
  };

  removeItem = (type, index) => {
    const data = [...this.state[type]];
    data.splice(index, 1);
    this.setState({ [type]: data });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (init() !== "success") return this.setState({ redirect: true });

    const formData = new FormData();

    formData.append("project_name", this.state.project_name);
    formData.append("project_category", this.state.project_category);
    formData.append("project_location", this.state.project_location);
    formData.append("project_type", this.state.project_type);
    formData.append("industry", this.state.industry);
    formData.append("project_overview", this.state.project_overview);

    formData.append(
      "challenges",
      JSON.stringify(this.state.challenges.filter(Boolean))
    );
    formData.append(
      "solutions",
      JSON.stringify(this.state.solutions.filter(Boolean))
    );
    formData.append(
      "key_info",
      JSON.stringify(
        this.state.key_info.filter((i) => i.key && i.value)
      )
    );

    if (this.state.project_banner) {
      formData.append("project_banner", this.state.project_banner);
    }

    this.state.project_gallery.forEach((file) => {
      formData.append("project_gallery", file);
    });

    try {
      await axios.post(Constants.postUrls.createProject, formData);
      this.setState({
        notification: true,
        message: "Project added successfully",
      });
      setTimeout(() => this.setState({ redirect: true }), 2000);
    } catch (err) {
        console.log(err);
        
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong",
      });
    }
  };

  render() {
    if (this.state.redirect) return <Navigate to="/projects" replace />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info">
              <MDTypography color="white">Add Project</MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="Project Name"
                      name="project_name"
                      onChange={this.handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                      <InputLabel>Category</InputLabel>
                      <Select
                        name="project_category"
                        value={this.state.project_category}
                        onChange={this.handleChange}
                        style={{
                            height: "45px"
                        }}
                      >
                        {this.state.categories.map((c) => (
                          <MenuItem key={c._id} value={c._id}>
                            {c.category}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      label="Project Overview"
                      name="project_overview"
                      onChange={this.handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Industry"
                      name="industry"
                      onChange={this.handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Project Location"
                      name="project_location"
                      onChange={this.handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Project Type"
                      name="project_type"
                      onChange={this.handleChange}
                    />
                  </Grid>

                  {/* Challenges */}
                  <Grid item xs={12}>
                    <MDTypography>Challenges</MDTypography>
                    {this.state.challenges.map((item, i) => (
                      <Grid container spacing={1} key={`challenge-${i}`}>
                        <Grid item xs={11}>
                          <TextField
                            fullWidth
                            value={item}
                            onChange={(e) =>
                              this.handleArrayChange("challenges", i, e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <IconButton onClick={() => this.removeItem("challenges", i)}>
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    ))}
                    <MDButton size="small" onClick={() => this.addItem("challenges", "")}>
                      <AddIcon /> Add Challenge
                    </MDButton>
                  </Grid>

                  {/* Solutions */}
                  <Grid item xs={12}>
                    <MDTypography>Solutions</MDTypography>
                    {this.state.solutions.map((item, i) => (
                      <Grid container spacing={1} key={`solution-${i}`}>
                        <Grid item xs={11}>
                          <TextField
                            fullWidth
                            value={item}
                            onChange={(e) =>
                              this.handleArrayChange("solutions", i, e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <IconButton onClick={() => this.removeItem("solutions", i)}>
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    ))}
                    <MDButton size="small" onClick={() => this.addItem("solutions", "")}>
                      <AddIcon /> Add Solution
                    </MDButton>
                  </Grid>

                  {/* Key Info */}
                  <Grid item xs={12}>
                    <MDTypography>Key Project Info</MDTypography>
                    {this.state.key_info.map((info, i) => (
                      <Grid container spacing={1} key={`keyinfo-${i}`}>
                        <Grid item xs={5}>
                          <TextField
                            fullWidth
                            label="Key"
                            value={info.key}
                            onChange={(e) =>
                              this.handleKeyInfoChange(i, "key", e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Value"
                            value={info.value}
                            onChange={(e) =>
                              this.handleKeyInfoChange(i, "value", e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <IconButton onClick={() => this.removeItem("key_info", i)}>
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    ))}
                    <MDButton
                      size="small"
                      onClick={() => this.addItem("key_info", { key: "", value: "" })}
                    >
                      <AddIcon /> Add Info
                    </MDButton>
                  </Grid>

                  {/* Files */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="file"
                      label="Banner"
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) =>
                        this.setState({ project_banner: e.target.files[0] })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="file"
                      label="Gallery"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ multiple: true }}
                      onChange={(e) =>
                        this.setState({
                          project_gallery: Array.from(e.target.files),
                        })
                      }
                    />
                  </Grid>
                </Grid>

                <MDBox mt={3}>
                  <MDButton type="submit" color="info">
                    Create Project
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>

            <MDSnackbar
              open={this.state.notification}
              content={this.state.message}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
